var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSplimit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorCamera240)",
    d: "M2 8.25A3.25 3.25 0 0 1 5.25 5H7l1.332-1.998A2.25 2.25 0 0 1 10.204 2h3.592a2.25 2.25 0 0 1 1.872 1.002L17 5h1.75A3.25 3.25 0 0 1 22 8.25v9.5A3.25 3.25 0 0 1 18.75 21H5.25A3.25 3.25 0 0 1 2 17.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorCamera241)",
    fillOpacity: 0.5,
    d: "M2 8.25A3.25 3.25 0 0 1 5.25 5H7l1.332-1.998A2.25 2.25 0 0 1 10.204 2h3.592a2.25 2.25 0 0 1 1.872 1.002L17 5h1.75A3.25 3.25 0 0 1 22 8.25v9.5A3.25 3.25 0 0 1 18.75 21H5.25A3.25 3.25 0 0 1 2 17.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorCamera243)",
    fillRule: "evenodd",
    d: "M12 17a4.5 4.5 0 1 0 0-9a4.5 4.5 0 0 0 0 9",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorCamera242)",
    d: "M15 12.5a3 3 0 1 1-6 0a3 3 0 0 1 6 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#fluentColorCamera244)",
    d: "M18.5 10a1.5 1.5 0 1 0 0-3a1.5 1.5 0 0 0 0 3"
  }), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "fluentColorCamera240",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "rotate(41.108 -4.919 .133)scale(29.8616 62.1235)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f08af4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.535,
    stopColor: "#9c6cfe"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4e44db"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fluentColorCamera241",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(.5 6.9091 -7.19332 .52057 14.5 14.09)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#312a9a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#312a9a",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "fluentColorCamera242",
    cx: 0,
    cy: 0,
    r: 1,
    gradientTransform: "matrix(5.5 6.5 -6.5 5.5 8 8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.243,
    stopColor: "#3bd5ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2052cb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorCamera243",
    x1: 9.193,
    x2: 13.693,
    y1: 8,
    y2: 18.688,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#decbff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "fluentColorCamera244",
    x1: 17,
    x2: 20,
    y1: 7.75,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#f08af4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f462ab"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSplimit);
export default __webpack_public_path__ + "static/media/splimit.cba5bb3e11ae60a12b37e6c8c77c108d.svg";
export { ForwardRef as ReactComponent };